/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Tab_Jobs_DescInputs */

const en_landing_tab_jobs_desc = /** @type {(inputs: Landing_Tab_Jobs_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search across Adzuna, Jooble, and Arbeitnow in one interface. AI scores how well your profile matches each role, so you only apply where you'll actually land interviews.`)
};

const de_landing_tab_jobs_desc = /** @type {(inputs: Landing_Tab_Jobs_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suche auf Adzuna, Jooble und Arbeitnow in einer Oberfläche. KI bewertet, wie gut dein Profil zu jeder Stelle passt — damit du dich nur dort bewirbst, wo du tatsächlich Interviews bekommst.`)
};

const fr_landing_tab_jobs_desc = /** @type {(inputs: Landing_Tab_Jobs_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search across Adzuna, Jooble, and Arbeitnow in one interface. AI scores how well your profile matches each role, so you only apply where you'll actually land interviews.`)
};

const es_landing_tab_jobs_desc = /** @type {(inputs: Landing_Tab_Jobs_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search across Adzuna, Jooble, and Arbeitnow in one interface. AI scores how well your profile matches each role, so you only apply where you'll actually land interviews.`)
};

const it_landing_tab_jobs_desc = /** @type {(inputs: Landing_Tab_Jobs_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search across Adzuna, Jooble, and Arbeitnow in one interface. AI scores how well your profile matches each role, so you only apply where you'll actually land interviews.`)
};

const nl_landing_tab_jobs_desc = /** @type {(inputs: Landing_Tab_Jobs_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search across Adzuna, Jooble, and Arbeitnow in one interface. AI scores how well your profile matches each role, so you only apply where you'll actually land interviews.`)
};

const pl_landing_tab_jobs_desc = /** @type {(inputs: Landing_Tab_Jobs_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search across Adzuna, Jooble, and Arbeitnow in one interface. AI scores how well your profile matches each role, so you only apply where you'll actually land interviews.`)
};

const fi_landing_tab_jobs_desc = /** @type {(inputs: Landing_Tab_Jobs_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search across Adzuna, Jooble, and Arbeitnow in one interface. AI scores how well your profile matches each role, so you only apply where you'll actually land interviews.`)
};

const da_landing_tab_jobs_desc = /** @type {(inputs: Landing_Tab_Jobs_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search across Adzuna, Jooble, and Arbeitnow in one interface. AI scores how well your profile matches each role, so you only apply where you'll actually land interviews.`)
};

const sv_landing_tab_jobs_desc = /** @type {(inputs: Landing_Tab_Jobs_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search across Adzuna, Jooble, and Arbeitnow in one interface. AI scores how well your profile matches each role, so you only apply where you'll actually land interviews.`)
};

/**
* | output |
* | --- |
* | "Search across Adzuna, Jooble, and Arbeitnow in one interface. AI scores how well your profile matches each role, so you only apply where you'll actually land..." |
*
* @param {Landing_Tab_Jobs_DescInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_tab_jobs_desc = /** @type {((inputs?: Landing_Tab_Jobs_DescInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Tab_Jobs_DescInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_tab_jobs_desc(inputs)
	if (locale === "fr") return fr_landing_tab_jobs_desc(inputs)
	if (locale === "es") return es_landing_tab_jobs_desc(inputs)
	if (locale === "it") return it_landing_tab_jobs_desc(inputs)
	if (locale === "nl") return nl_landing_tab_jobs_desc(inputs)
	if (locale === "pl") return pl_landing_tab_jobs_desc(inputs)
	if (locale === "fi") return fi_landing_tab_jobs_desc(inputs)
	if (locale === "da") return da_landing_tab_jobs_desc(inputs)
	if (locale === "sv") return sv_landing_tab_jobs_desc(inputs)
	return en_landing_tab_jobs_desc(inputs)
});